const FAQS = [
  {
    q: '香香漫画网址是什么？如何安全访问？',
    a: '香香漫画官网入口为读者提供安全稳定的阅读环境。建议通过收藏夹保存香香漫画网址以便快速访问，避免通过不明链接进入仿冒站点。本站承诺永久免费、无强制广告弹窗，为你的追更之旅保驾护航。',
  },
  {
    q: '香香漫画支持哪些漫画类型？更新频率如何？',
    a: '香香漫画网收录韩漫、日漫、国漫等多元类型的漫画作品，涵盖恋爱、热血、悬疑、古风、玄幻、美食等数十种题材。热门连载每日稳定更新，部分作品与海外同步上线，确保追更速度始终领先。',
  },
  {
    q: '什么是下拉式追更？和传统翻页有什么区别？',
    a: '下拉式追更是香香漫画独创的阅读模式，将漫画内容以纵向连续流的方式呈现，读者只需向下滑动即可连续阅读，无需频繁点击翻页按钮。这种方式更接近手机端的自然阅读习惯，大幅提升沉浸感和阅读效率。',
  },
  {
    q: '香香漫画上的漫画真的是免费全集吗？',
    a: '是的，香香漫画平台上所有漫画作品均为免费在线阅读。我们坚持开放共享的理念，不设付费墙。无论是经典全集还是热门连载，你都可以免费畅读。平台通过编辑推荐和专题策划帮助你发现更多好看的漫画。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            关于香香漫画，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {FAQS.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="text-base font-semibold text-foreground-900 font-heading flex items-start gap-3">
                <span className="shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs font-bold mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="mt-3 ml-9 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}